import { flattenTree } from 'components/base/MultiLevelDropdown/MultiLevelDropdown.utils';
import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { teamsTreeSelectorWithContribCountSelector } from 'state/selectors/teamsTreeSelectorWithContribCountSelector';

export function useTeamsTree() {
  const teamsTree = useSelector(teamsTreeSelectorWithContribCountSelector);
  const flatTeams = useMemo(
    () => flattenTree(teamsTree, 'children'),
    [teamsTree]
  );

  return { teamsTree, flatTeams };
}
